<template>
  <span
    class="bicon d-inline-block"
    @click="emit('click', $event)"
  >
    <font-awesome-icon
      v-if="Array.isArray(iconObject) || (typeof iconObject === 'string' && iconObject.substr(0,10) !== 'bobcaticon')"
      :fixed-width="fixedWidth"
      :rotation="rotation"
      :flip="flip"
      :icon="iconObject"
    />
    <bicon
      v-else
      :class="iconObject"
    />
  </span>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

const props = withDefaults(defineProps<{
  icon: string | [string, string]
  fixedWidth?: boolean
  flip?: boolean | 'horizontal' | 'vertical' | 'both'
  rotation?: 90 | 180 | 270 | '90' | '180' | '270'
}>(), {
  fixedWidth: false
})

const emit = defineEmits<{(e: 'click', value: MouseEvent): void
}>()

const iconObject = computed(() => {
  const icon = props.icon
  if (Array.isArray(icon)) return icon
  if (icon === '~~~~~') return 'spinner'
  try {
    return JSON.parse(icon)
  } catch (e) {
    return icon
  }
})
</script>
